<template>
  <router-view v-if="session"
               :session="session"
               @updated="fetchData">
  </router-view>
</template>
<script>
import deviceEventService from '../../../../ml/services/deviceEventService';

export default {
  data() {
    return {
      busy: false,
      session: null,
    }
  },
  computed: {
    sessionID() {
      return parseInt(this.$route.params.sessionID);
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.busy = true;
      deviceEventService.getSession(this.sessionID)
        .then(data => {
          this.session = data;
        })
        .catch(err => {
          console.log(err.message);
          this.$toast.error('Session not found');
          this.$router.replace({name: `${this.$root.routePrefix}.device_sessions`});
        })
        .finally(() => {
          this.busy = false;
        })
    }
  }
}
</script>
